import { EntitySection, RecentDocument } from "v2/store/entityDocumentsApi";

export type RecentDocumentGroup = {
  section: EntitySection | null;
  documents: RecentDocument[];
};

const SECTION_ORDER: EntitySection[] = [
  "About the company",
  "Books & financials",
  "Tax",
];

// `null` section = unclassified upload; rendered first with no subheader.
export const groupRecentBySection = (
  documents: RecentDocument[]
): RecentDocumentGroup[] => {
  const ungrouped = documents.filter((document) => document.section === null);
  const sectioned = SECTION_ORDER.map((section) => ({
    section,
    documents: documents.filter((document) => document.section === section),
  })).filter((group) => group.documents.length > 0);

  if (ungrouped.length === 0) return sectioned;
  return [{ section: null, documents: ungrouped }, ...sectioned];
};
